import { render, staticRenderFns } from "./return-case-pool.vue?vue&type=template&id=117ba662&scoped=true"
import script from "./return-case-pool.vue?vue&type=script&lang=ts"
export * from "./return-case-pool.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "117ba662",
  null
  
)

export default component.exports